import React from "react";
import BasicTable from "../../../common/BasicTable";
import {Box} from "@mui/system";
import importedStyles from "./templateStyles";
import CircularProgress from "@mui/material/CircularProgress";
import _ from "lodash";

export default function CampaignsTable({ rows, columns, totalCount, page, loading, handlePageChange, clickableRow, handleTableRowClick, handleTableCellClick, order, orderBy, onRequestSort }) {

    if(loading && _.isEmpty(rows)) {
        return(
            <Box sx={importedStyles.emptyContainer}>
                <CircularProgress size={25} sx={{ color: '#003300'}}/>
            </Box>
        )
    }

    return (
        <BasicTable
            rows={rows}
            columns={columns}
            totalCount={totalCount}
            handlePageChange={handlePageChange}
            page={page}
            isPaginationDisabled={loading}
            clickableRow={clickableRow}
            handleTableRowClick={handleTableRowClick}
            handleTableCellClick={handleTableCellClick}
            tableHeadStyle={styles.ellipsis}
            order={order}
            orderBy={orderBy}
            onRequestSort={onRequestSort}
        />
    );
}

const styles = {
    ellipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}